var map = {
	"./layouts/card": 16,
	"./layouts/card/": 16,
	"./layouts/card/index": 16,
	"./layouts/card/index.tsx": 16,
	"./layouts/card/style.module": 97,
	"./layouts/card/style.module.scss": 97,
	"./layouts/components/breadcrumbs": 122,
	"./layouts/components/breadcrumbs/": 122,
	"./layouts/components/breadcrumbs/index": 122,
	"./layouts/components/breadcrumbs/index.tsx": 122,
	"./layouts/components/breadcrumbs/style.module": 173,
	"./layouts/components/breadcrumbs/style.module.scss": 173,
	"./layouts/components/container": 42,
	"./layouts/components/container/": 42,
	"./layouts/components/container/index": 42,
	"./layouts/components/container/index.tsx": 42,
	"./layouts/components/container/style.module": 124,
	"./layouts/components/container/style.module.scss": 124,
	"./layouts/components/footer": 123,
	"./layouts/components/footer/": 123,
	"./layouts/components/footer/index": 123,
	"./layouts/components/footer/index.tsx": 123,
	"./layouts/components/footer/style.module": 86,
	"./layouts/components/footer/style.module.scss": 86,
	"./layouts/components/loading_indicator": 60,
	"./layouts/components/loading_indicator/": 60,
	"./layouts/components/loading_indicator/index": 60,
	"./layouts/components/loading_indicator/index.tsx": 60,
	"./layouts/components/nav_bar": 96,
	"./layouts/components/nav_bar/": 96,
	"./layouts/components/nav_bar/index": 96,
	"./layouts/components/nav_bar/index.tsx": 96,
	"./layouts/components/nav_bar/standalone": 327,
	"./layouts/components/nav_bar/standalone.tsx": 327,
	"./layouts/components/nav_bar/style.module": 35,
	"./layouts/components/nav_bar/style.module.scss": 35,
	"./layouts/components/notice_banner": 85,
	"./layouts/components/notice_banner/": 85,
	"./layouts/components/notice_banner/assets/sale_tag_icon": 174,
	"./layouts/components/notice_banner/assets/sale_tag_icon.svg": 174,
	"./layouts/components/notice_banner/index": 85,
	"./layouts/components/notice_banner/index.tsx": 85,
	"./layouts/components/notice_banner/standalone": 328,
	"./layouts/components/notice_banner/standalone.tsx": 328,
	"./layouts/components/notice_banner/style.module": 175,
	"./layouts/components/notice_banner/style.module.scss": 175,
	"./layouts/page": 94,
	"./layouts/page/": 94,
	"./layouts/page/index": 94,
	"./layouts/page/index.tsx": 94,
	"./layouts/page/style.module": 87,
	"./layouts/page/style.module.scss": 87,
	"./layouts/types": 329,
	"./layouts/types.ts": 329,
	"./marketing/pages/home/ielts": 1615,
	"./marketing/pages/home/ielts/": 1615,
	"./marketing/pages/home/ielts/assets/avatars": 1868,
	"./marketing/pages/home/ielts/assets/avatars.png": 1868,
	"./marketing/pages/home/ielts/index": 1615,
	"./marketing/pages/home/ielts/index.tsx": 1615,
	"./marketing/pages/home/ielts/sections/ai": 1211,
	"./marketing/pages/home/ielts/sections/ai/": 1211,
	"./marketing/pages/home/ielts/sections/ai/assets/ai_coaching_feature": 1843,
	"./marketing/pages/home/ielts/sections/ai/assets/ai_coaching_feature.png": 1843,
	"./marketing/pages/home/ielts/sections/ai/assets/ai_explanations_feature": 1844,
	"./marketing/pages/home/ielts/sections/ai/assets/ai_explanations_feature.png": 1844,
	"./marketing/pages/home/ielts/sections/ai/assets/ai_speaking_grading_feature": 1845,
	"./marketing/pages/home/ielts/sections/ai/assets/ai_speaking_grading_feature.png": 1845,
	"./marketing/pages/home/ielts/sections/ai/assets/ai_writing_grading_feature": 1846,
	"./marketing/pages/home/ielts/sections/ai/assets/ai_writing_grading_feature.png": 1846,
	"./marketing/pages/home/ielts/sections/ai/assets/sparkle_bg": 1847,
	"./marketing/pages/home/ielts/sections/ai/assets/sparkle_bg.svg": 1847,
	"./marketing/pages/home/ielts/sections/ai/assets/sparkle_icon": 1848,
	"./marketing/pages/home/ielts/sections/ai/assets/sparkle_icon.svg": 1848,
	"./marketing/pages/home/ielts/sections/ai/index": 1211,
	"./marketing/pages/home/ielts/sections/ai/index.tsx": 1211,
	"./marketing/pages/home/ielts/sections/ai/style.module": 1849,
	"./marketing/pages/home/ielts/sections/ai/style.module.scss": 1849,
	"./marketing/pages/home/ielts/sections/apps": 1212,
	"./marketing/pages/home/ielts/sections/apps/": 1212,
	"./marketing/pages/home/ielts/sections/apps/assets/app_store_icon": 1850,
	"./marketing/pages/home/ielts/sections/apps/assets/app_store_icon.svg": 1850,
	"./marketing/pages/home/ielts/sections/apps/assets/device_icon": 1851,
	"./marketing/pages/home/ielts/sections/apps/assets/device_icon.svg": 1851,
	"./marketing/pages/home/ielts/sections/apps/assets/flashcard_app": 1852,
	"./marketing/pages/home/ielts/sections/apps/assets/flashcard_app.png": 1852,
	"./marketing/pages/home/ielts/sections/apps/assets/play_store_icon": 1853,
	"./marketing/pages/home/ielts/sections/apps/assets/play_store_icon.svg": 1853,
	"./marketing/pages/home/ielts/sections/apps/assets/prep_app": 1854,
	"./marketing/pages/home/ielts/sections/apps/assets/prep_app.png": 1854,
	"./marketing/pages/home/ielts/sections/apps/index": 1212,
	"./marketing/pages/home/ielts/sections/apps/index.tsx": 1212,
	"./marketing/pages/home/ielts/sections/features": 1213,
	"./marketing/pages/home/ielts/sections/features/": 1213,
	"./marketing/pages/home/ielts/sections/features/assets/analytics_feature": 1855,
	"./marketing/pages/home/ielts/sections/features/assets/analytics_feature.png": 1855,
	"./marketing/pages/home/ielts/sections/features/assets/practice_tests_feature": 1856,
	"./marketing/pages/home/ielts/sections/features/assets/practice_tests_feature.png": 1856,
	"./marketing/pages/home/ielts/sections/features/assets/score_predictor_feature": 1857,
	"./marketing/pages/home/ielts/sections/features/assets/score_predictor_feature.png": 1857,
	"./marketing/pages/home/ielts/sections/features/assets/star_icon": 1858,
	"./marketing/pages/home/ielts/sections/features/assets/star_icon.svg": 1858,
	"./marketing/pages/home/ielts/sections/features/assets/student_help_feature": 1859,
	"./marketing/pages/home/ielts/sections/features/assets/student_help_feature.png": 1859,
	"./marketing/pages/home/ielts/sections/features/index": 1213,
	"./marketing/pages/home/ielts/sections/features/index.tsx": 1213,
	"./marketing/pages/home/ielts/sections/value_props": 1214,
	"./marketing/pages/home/ielts/sections/value_props/": 1214,
	"./marketing/pages/home/ielts/sections/value_props/assets/concentric_circles": 1860,
	"./marketing/pages/home/ielts/sections/value_props/assets/concentric_circles.svg": 1860,
	"./marketing/pages/home/ielts/sections/value_props/assets/magic_wand_icon": 1861,
	"./marketing/pages/home/ielts/sections/value_props/assets/magic_wand_icon.svg": 1861,
	"./marketing/pages/home/ielts/sections/value_props/index": 1214,
	"./marketing/pages/home/ielts/sections/value_props/index.tsx": 1214,
	"./marketing/pages/home/ielts/sections/value_props/style.module": 2315,
	"./marketing/pages/home/ielts/sections/value_props/style.module.scss": 2315,
	"./marketing/pages/home/ielts/sections/video_based_learning": 1215,
	"./marketing/pages/home/ielts/sections/video_based_learning/": 1215,
	"./marketing/pages/home/ielts/sections/video_based_learning/assets/eliot_headshot": 1862,
	"./marketing/pages/home/ielts/sections/video_based_learning/assets/eliot_headshot.png": 1862,
	"./marketing/pages/home/ielts/sections/video_based_learning/assets/focused_lesson_card": 1863,
	"./marketing/pages/home/ielts/sections/video_based_learning/assets/focused_lesson_card.png": 1863,
	"./marketing/pages/home/ielts/sections/video_based_learning/assets/lesson_cards_bg": 1864,
	"./marketing/pages/home/ielts/sections/video_based_learning/assets/lesson_cards_bg.png": 1864,
	"./marketing/pages/home/ielts/sections/video_based_learning/assets/play_icon": 1865,
	"./marketing/pages/home/ielts/sections/video_based_learning/assets/play_icon.svg": 1865,
	"./marketing/pages/home/ielts/sections/video_based_learning/assets/video_thumbnail": 1866,
	"./marketing/pages/home/ielts/sections/video_based_learning/assets/video_thumbnail.png": 1866,
	"./marketing/pages/home/ielts/sections/video_based_learning/index": 1215,
	"./marketing/pages/home/ielts/sections/video_based_learning/index.tsx": 1215,
	"./marketing/pages/home/ielts/sections/video_based_learning/style.module": 761,
	"./marketing/pages/home/ielts/sections/video_based_learning/style.module.scss": 761,
	"./marketing/pages/home/ielts/sections/wall_of_love": 1216,
	"./marketing/pages/home/ielts/sections/wall_of_love/": 1216,
	"./marketing/pages/home/ielts/sections/wall_of_love/assets/waqeeb_headshot": 1867,
	"./marketing/pages/home/ielts/sections/wall_of_love/assets/waqeeb_headshot.png": 1867,
	"./marketing/pages/home/ielts/sections/wall_of_love/index": 1216,
	"./marketing/pages/home/ielts/sections/wall_of_love/index.tsx": 1216,
	"./marketing/pages/home/ielts/style.module": 1869,
	"./marketing/pages/home/ielts/style.module.scss": 1869,
	"./marketing/pages/plans/ielts": 1616,
	"./marketing/pages/plans/ielts/": 1616,
	"./marketing/pages/plans/ielts/index": 1616,
	"./marketing/pages/plans/ielts/index.tsx": 1616,
	"./marketing/pages/plans/ielts/sections/testimonials": 1217,
	"./marketing/pages/plans/ielts/sections/testimonials/": 1217,
	"./marketing/pages/plans/ielts/sections/testimonials/assets/neha_headshot": 1870,
	"./marketing/pages/plans/ielts/sections/testimonials/assets/neha_headshot.png": 1870,
	"./marketing/pages/plans/ielts/sections/testimonials/assets/saurav_headshot": 1871,
	"./marketing/pages/plans/ielts/sections/testimonials/assets/saurav_headshot.png": 1871,
	"./marketing/pages/plans/ielts/sections/testimonials/index": 1217,
	"./marketing/pages/plans/ielts/sections/testimonials/index.tsx": 1217
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2657;